document.addEventListener("turbo:load", event => {
  gtag('config', 'UA-0000000-1')
})
